<template>
  <div class="page-wrapper storybook-cncLoading">
    <StorybookTemplate title="cncLoading" pathComponent="/shared/elements/global/v1/CncLoading.vue" :propList="propList" :form.sync="form">
      <CncLoading v-bind="form">{{ form.name }}</CncLoading>
    </StorybookTemplate>
  </div>
</template>

<script>
export default {
  components: {
    StorybookTemplate: () => import('../../../../components/StorybookTemplate.vue')
  },
  data () {
    return {
      propList: [
        // {
        //   name: 'type', type: 'select', param: 'type', default: 'filled',
        //   option: [
        //     { label: 'filled', name: 'Filled' },
        //     { label: 'tonal', name: 'Tonal' },
        //     { label: 'tonal-alt', name: 'Tonal alt' },
        //     { label: 'neutral', name: 'Neutral' },
        //     { label: 'ghost', name: 'Ghost' },
        //     { label: 'filled-on-color', name: 'Filled on color' },
        //     { label: 'outline-on-color', name: 'Outline on color' },
        //   ]
        // },
        // {
        //   name: 'typeWidth', type: 'select', param: 'typeWidth', default: 'hug',
        //   option: [
        //     { label: 'hug', name: 'Hug' },
        //     { label: 'fixed', name: 'Fixed' },
        //     { label: 'fill', name: 'Fill' },
        //   ]
        // },
        {
          name: 'size',
          type: 'select',
          param: 'size',
          default: 'large',
          option: [
            { label: 'small', name: 'Small' },
            // { label: 'medium', name: 'Medium' },
            { label: 'large', name: 'Large' }
          ]
        },
        // {
        //   name: 'leftIcon', type: 'object', param: 'leftIcon',
        //   objectKey: [
        //     { key: 'type', value: 'svg', type: 'select', option: ['svg', 'icon'] },
        //     { key: 'name', type: 'input', value: 'IconHome' },
        //   ]
        // },
        // {
        //   name: 'rightIcon', type: 'object', param: 'rightIcon',
        //   objectKey: [
        //     { key: 'type', value: 'svg', type: 'select', option: ['svg', 'icon'] },
        //     { key: 'name', type: 'input', value: 'IconSquareRight' },
        //   ]
        // },
        // { name: 'width', type: 'slider', param: 'width', min: 0, max: 300 },
        { name: 'withText', type: 'boolean', param: 'withText' },
        { name: 'onColor', type: 'boolean', param: 'onColor' }
        // { name: 'badge', type: 'input', param: 'badge' },
        // { name: 'name', type: 'input', param: 'name' },
      ],

      form: {
        // name: 'Button',
        // typeWidth: 'hug',
        // type: 'filled',
        size: 'large',
        // width: 200,
        onColor: false,
        withText: false
        // badge: 6,
        // leftIcon: { type: 'svg', name: 'IconCreate' },
        // rightIcon:  { type: 'svg', name: 'IconChat' },
      }
    }
  }
}
</script>
